import { Heading } from "../../design/heading";
import { useMatter } from "../../contexts/MatterContext";
import DeleteMatterButton from "../../components/DeleteMatterButton";
import ActivityList from "./components/ActivityList";
import AnalysisOverview from "./components/AnalysisOverview";
import { MatterOverview } from "./components/MatterOverView";
import EmptyStateView from "../../components/EmptyStateView";
import NoMatterView from "../../components/NoMatterView";
import TaskList from "./components/TaskList";

const DashboardPage: React.FC = () => {
  const { currentMatterId, currentMatter } = useMatter();

  if (!currentMatterId) {
    return <NoMatterView />;
  }

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between w-full">
        <Heading className="text-2xl font-bold">
          {currentMatter?.identifier ?? "Unknown"}
        </Heading>
        {currentMatter && <DeleteMatterButton matterId={currentMatter._id} />}
      </div>
      {currentMatter && (
        <>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <MatterOverview currentMatter={currentMatter} />
            <AnalysisOverview />
          </div>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <TaskList />
            <ActivityList />
          </div>
        </>
      )}
    </div>
  );
};

export default DashboardPage;
